module.exports = __webpack_public_path__ + "static/media/barcode.bf5d9cb4.png";